export const mockDesignationsListResponse = {
  rescode: 1,
  message: "Designations fetched",
  data: [
    {
      id: 1, clinic_id: null, name: "Occupational Therapist", short_name: "OT", is_default: 1, is_active: 1, sort_order: 1,
      services: [
        { id: 1, name: "Occupational Therapy", price: 1000, duration_minutes: 60, color: "#2563EB" },
        { id: 7, name: "Sensory Integration Therapy", price: 1000, duration_minutes: 45, color: "#6366F1" },
        { id: 13, name: "OT Assessment", price: 1200, duration_minutes: 60, color: "#2563EB" },
      ],
    },
    {
      id: 2, clinic_id: null, name: "Speech Therapist", short_name: "ST", is_default: 1, is_active: 1, sort_order: 2,
      services: [
        { id: 2, name: "Speech Therapy", price: 900, duration_minutes: 45, color: "#7C3AED" },
        { id: 14, name: "Speech Assessment", price: 1200, duration_minutes: 60, color: "#7C3AED" },
        { id: 10, name: "Parent Training Session", price: 500, duration_minutes: 45, color: "#F59E0B" },
      ],
    },
    {
      id: 3, clinic_id: null, name: "Special Educator", short_name: "SE", is_default: 1, is_active: 1, sort_order: 3,
      services: [
        { id: 5, name: "Special Education", price: 800, duration_minutes: 60, color: "#0891B2" },
      ],
    },
    {
      id: 4, clinic_id: null, name: "Physiotherapist", short_name: "PT", is_default: 1, is_active: 1, sort_order: 4,
      services: [
        { id: 4, name: "Physiotherapy", price: 800, duration_minutes: 45, color: "#EA580C" },
      ],
    },
    {
      id: 5, clinic_id: null, name: "ABA Therapist", short_name: "ABA", is_default: 1, is_active: 1, sort_order: 5,
      services: [
        { id: 3, name: "ABA Therapy", price: 1200, duration_minutes: 60, color: "#059669" },
        { id: 6, name: "Behaviour Therapy", price: 1000, duration_minutes: 45, color: "#D97706" },
      ],
    },
    {
      id: 6, clinic_id: null, name: "Clinical Psychologist", short_name: "PSY", is_default: 1, is_active: 1, sort_order: 6,
      services: [
        { id: 11, name: "Counseling Session", price: 1000, duration_minutes: 45, color: "#8B5CF6" },
        { id: 15, name: "IQ Assessment", price: 2000, duration_minutes: 90, color: "#059669" },
        { id: 16, name: "Autism Screening", price: 1500, duration_minutes: 60, color: "#DC2626" },
      ],
    },
    {
      id: 7, clinic_id: null, name: "Behaviour Therapist", short_name: "BT", is_default: 1, is_active: 1, sort_order: 7,
      services: [
        { id: 6, name: "Behaviour Therapy", price: 1000, duration_minutes: 45, color: "#D97706" },
      ],
    },
    {
      id: 8, clinic_id: null, name: "Senior Speech Therapist", short_name: "SST", is_default: 1, is_active: 1, sort_order: 8,
      services: [
        { id: 2, name: "Speech Therapy", price: 900, duration_minutes: 45, color: "#7C3AED" },
        { id: 14, name: "Speech Assessment", price: 1200, duration_minutes: 60, color: "#7C3AED" },
      ],
    },
    {
      id: 9, clinic_id: null, name: "Senior OT", short_name: "SOT", is_default: 1, is_active: 1, sort_order: 9,
      services: [
        { id: 1, name: "Occupational Therapy", price: 1000, duration_minutes: 60, color: "#2563EB" },
        { id: 13, name: "OT Assessment", price: 1200, duration_minutes: 60, color: "#2563EB" },
      ],
    },
    {
      id: 10, clinic_id: null, name: "Pediatrician", short_name: "DR", is_default: 1, is_active: 1, sort_order: 10,
      services: [
        { id: 19, name: "Pediatric Consultation", price: 800, duration_minutes: 30, color: "#DC2626" },
        { id: 21, name: "Follow-up Consultation", price: 500, duration_minutes: 20, color: "#64748B" },
      ],
    },
  ],
};

export const mockDesignationServicesResponse = {
  rescode: 1,
  data: { services: [
    { id: 1, name: "Occupational Therapy", price: 1000, duration_minutes: 60, color: "#2563EB" },
    { id: 7, name: "Sensory Integration Therapy", price: 1000, duration_minutes: 45, color: "#6366F1" },
  ]},
};

export const mockDesignationDropdownResponse = {
  rescode: 1,
  data: {
    designations: [
      // Clinical Staff
      { id: 1, name: "Occupational Therapist", short_name: "OT", role_id: 5, is_clinical: 1, needs_login: 0 },
      { id: 2, name: "Speech Therapist", short_name: "ST", role_id: 5, is_clinical: 1, needs_login: 0 },
      { id: 3, name: "Special Educator", short_name: "SE", role_id: 5, is_clinical: 1, needs_login: 0 },
      { id: 4, name: "Physiotherapist", short_name: "PT", role_id: 5, is_clinical: 1, needs_login: 0 },
      { id: 5, name: "ABA Therapist", short_name: "ABA", role_id: 5, is_clinical: 1, needs_login: 0 },
      { id: 6, name: "Clinical Psychologist", short_name: "PSY", role_id: 5, is_clinical: 1, needs_login: 0 },
      { id: 7, name: "Behaviour Therapist", short_name: "BT", role_id: 5, is_clinical: 1, needs_login: 0 },
      { id: 8, name: "Senior Speech Therapist", short_name: "SST", role_id: 5, is_clinical: 1, needs_login: 0 },
      { id: 9, name: "Senior OT", short_name: "SOT", role_id: 5, is_clinical: 1, needs_login: 0 },
      { id: 10, name: "Pediatrician", short_name: "DR", role_id: 5, is_clinical: 1, needs_login: 0 },
      { id: 11, name: "Nurse", short_name: "NRS", role_id: 5, is_clinical: 0, needs_login: 0 },
      { id: 12, name: "Shadow Teacher", short_name: "SHD", role_id: 5, is_clinical: 1, needs_login: 0 },
      { id: 13, name: "Intern / Trainee", short_name: "INT", role_id: 5, is_clinical: 0, needs_login: 0 },
      // Support Staff
      { id: 14, name: "Receptionist", short_name: "RCP", role_id: 3, is_clinical: 0, needs_login: 1 },
      { id: 15, name: "Manager", short_name: "MGR", role_id: 5, is_clinical: 0, needs_login: 1 },
      { id: 16, name: "Accountant", short_name: "ACC", role_id: 4, is_clinical: 0, needs_login: 1 },
      { id: 17, name: "HR", short_name: "HR", role_id: 5, is_clinical: 0, needs_login: 1 },
      { id: 18, name: "Cleaner", short_name: "CLN", role_id: 5, is_clinical: 0, needs_login: 0 },
      { id: 19, name: "Security", short_name: "SEC", role_id: 5, is_clinical: 0, needs_login: 0 },
      { id: 20, name: "Driver", short_name: "DRV", role_id: 5, is_clinical: 0, needs_login: 0 },
      { id: 21, name: "Peon / Helper", short_name: "HLP", role_id: 5, is_clinical: 0, needs_login: 0 },
      { id: 22, name: "IT Support", short_name: "IT", role_id: 5, is_clinical: 0, needs_login: 1 },
    ],
  },
};
